import { Component } from '@angular/core';

@Component({
    template: `
        To install CASLink as an App on your device tap the Menu
                        <mat-icon color="primary">ios_share</mat-icon>
                        button and then 'Add to Home Screen'
                        <mat-icon color="primary">add_box</mat-icon>
                        button.
  `
})
export class IosMessageComponent {
}
